import initSettingModal from '../modal.js'

$(document).on('turbolinks:load', () => {
  initModal()
})

const initModal = () => {
  const {
    onClickOpenCreateModal,
    onClickOpenEditModals,
    onClickOpenDeleteModals,
    onClickCloseModal,
    onClickCloseDeleteModal,
  } = initSettingModal({target: 'shop'})

  onClickOpenCreateModal()
  onClickOpenEditModals()
  onClickOpenDeleteModals()
  onClickCloseModal()
  onClickCloseDeleteModal()
}

const getBrandId = (element, prefix) => {
  const classNames = element.attr('class').split(' ')
  const elementId = classNames.find(className =>
    className.includes(prefix)
  )

  return elementId.replace(prefix, '')
}
